/**
 * Utility functions for managing Mux cache
 * Can be called from browser console for manual cache invalidation
 */

import { clearMuxCache } from "@/lib/muxApi";

/**
 * Clear all Mux caches and reload the page
 * Usage from browser console: window.invalidateMuxCache()
 */
export function invalidateMuxCacheAndReload(): void {
  console.log("[muxCacheUtils] Invalidating all Mux caches...");
  clearMuxCache();
  console.log("[muxCacheUtils] Cache cleared. Reloading page...");
  window.location.reload();
}

/**
 * Check current cache status
 * Usage from browser console: window.checkMuxCacheStatus()
 */
export function checkMuxCacheStatus(): void {
  if (typeof window === "undefined" || !window.localStorage) {
    console.log("[muxCacheUtils] localStorage not available");
    return;
  }

  const LOCALSTORAGE_PREFIX = "mux_cache_";
  const keys = Object.keys(localStorage).filter(key => key.startsWith(LOCALSTORAGE_PREFIX));
  
  console.log(`[muxCacheUtils] Found ${keys.length} cached entries:`);
  
  keys.forEach(key => {
    try {
      const stored = localStorage.getItem(key);
      if (stored) {
        const parsed = JSON.parse(stored);
        const age = Date.now() - parsed.timestamp;
        const ageMinutes = Math.floor(age / 60000);
        const cacheKey = key.replace(LOCALSTORAGE_PREFIX, "");
        
        console.log(`  - ${cacheKey}: ${parsed.data.length} items, age: ${ageMinutes}m`);
      }
    } catch (error) {
      console.warn(`  - ${key}: failed to parse`, error);
    }
  });
}

// Expose to window for easy console access
if (typeof window !== "undefined") {
  (window as unknown as Record<string, unknown>).invalidateMuxCache = invalidateMuxCacheAndReload;
  (window as unknown as Record<string, unknown>).checkMuxCacheStatus = checkMuxCacheStatus;
}
